import $ from "jquery";

function ScrollHandler() {
	this.handlingIt = false;
	this.reachedBottom = false;
	this.screenClass = "c-page";
	this.scrollItems = [];
	this._setupScrollReveal();
	this._makeScrollItems();

	$(window).on("scroll", this._handleScroll.bind(this));
	$(window).on("resize", this._handleResize.bind(this));

	setTimeout(() => {
		this._handleScroll();
		document.body.classList.add("animations-setup")
	}, 1000);
}

ScrollHandler.prototype._makeScrollItems = function () {
	Array.from(document.querySelectorAll("." + this.screenClass)).forEach((el) => {
		this.scrollItems.push({
			el: el,
			loaded: false,
			triggeredAt: this._calculateScrollPos(el)
		});
	});
};

ScrollHandler.prototype._calculateScrollPos = function (el) {
	var bbox = el.getBoundingClientRect();
	return bbox.top + Math.round(bbox.height/2) + window.pageYOffset - window.innerHeight;
};

ScrollHandler.prototype._checkScrollItems = function () {
	var scrollPos = window.pageYOffset;
	var atBottom = scrollPos + 50 + window.innerHeight > document.body.scrollHeight;

	if (scrollPos < 10 ) {
        document.body.classList.add("reached-top");
	} else {
        document.body.classList.remove("reached-top");
	}

	// adds class when the scroll reaches the bottom
	if (atBottom && !this.reachedBottom) {
		this.reachedBottom = true;
		document.body.classList.add("reached-bottom");
	} else if (!atBottom && this.reachedBottom) {
		this.reachedBottom = false;
		document.body.classList.remove("reached-bottom");
	}

	this.scrollItems.forEach((item) => {
		if (item.loaded) {
			return;
		}
		if (scrollPos >= item.triggeredAt) {
			item.loaded = true;
			this.showEl(item.el);
		}
	});

	this.handlingIt = false;
};

ScrollHandler.prototype.showEl = function (el) {
	let numbers = Array.from(el.querySelectorAll(".c-fancy-number"));
	this.showNumbers(numbers);

	let items = Array.from(el.querySelectorAll("[data-scroll-reveal]"));
	this.showItems(items);
};

ScrollHandler.prototype.showNumbers = function (numbers) {
	var showNumberEvent = new Event("show-fancy-number");
	let timeout = 0;
	numbers.forEach((num) => {
		setTimeout(() => {
			num.dispatchEvent(showNumberEvent);
		}, timeout);
		timeout += 200;
	});
};

ScrollHandler.prototype.showItems = function (items) {
	let timeout = 0;
	items.forEach((item) => {
		setTimeout(() => {
			let sr = item.dataset.scrollReveal || "";
			if (sr.length > 0) {
				sr = "-" + sr;
			}
			item.classList.remove("u-show-on-scroll" + sr);
		}, timeout);
		timeout += 200;
	});
};

ScrollHandler.prototype._handleScroll = function (e) {
	if (!this.handlingIt) {
		this.handlingIt = true;
		window.requestAnimationFrame(this._checkScrollItems.bind(this));
	}
}

ScrollHandler.prototype._handleResize = function (e) {
	this.scrollItems.forEach((item) => {
		item.triggeredAt = this._calculateScrollPos(item.el);
	});

	this._handleScroll();
}

ScrollHandler.prototype._setupScrollReveal = function () {
	Array.from(document.querySelectorAll("[data-scroll-reveal]")).forEach((el) => {
		let sr = el.dataset.scrollReveal || "";
		if (sr.length > 0) {
			sr = "-" + sr;
		}
		el.classList.add("u-show-on-scroll" + sr);
	});
}

module.exports = new ScrollHandler();


// WEBPACK FOOTER //
// ./source/assets/scripts/scroll-handler.js